import { createContext, useContext } from 'react';
import { ValuesSize } from './types';

type ValuesContextValue = {
  size: ValuesSize;
};

export const ValuesContext = createContext<ValuesContextValue>({ size: 'medium' });

/**
 * Provides Values component context
 */
export const useValuesContext = () => {
  return useContext(ValuesContext);
};
